import React from 'react';

interface SummaryRowProps {
  label: string;
  value?: string;
  children?: React.ReactNode;
}

export function SummaryRow({ label, value, children }: SummaryRowProps) {
  return (
    <div className='flex items-start justify-between py-2'>
      <span className='text-sm text-sd-muted-foreground'>{label}</span>
      {children ?? <span className='text-sm font-medium text-end max-w-[60%]'>{value || '—'}</span>}
    </div>
  );
}
